<template>
  <el-dialog
    title="查看申请退款信息"
    :visible.sync="isShow"
    destroy-on-close
    width="800px"
    @close="closeDialog"
  >
    <div class="rj-row">
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            电汇单号：
          </div>
          <div>{{ formData.telegraphicTransferNum }}</div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            可用余额：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.unusedAmount }}元
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            退款金额：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.returnAmount }}元
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            收款单位：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.payee }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            银行账号：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.bankAccount }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            开户行：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.openBank }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            客户联行号：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.customerBankNo }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            SWIFT CODE：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.swiftCode }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            申请原因：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.reason }}
          </div>
        </div>
      </div>
    </div>

    <div class="rj-page-card__title" style="margin-top: 15px">
      审批记录
    </div>

    <el-table
      :data="tableData"
      border
      height="180"
    >
      <el-table-column prop="approver" label="审批人" align="left" />
      <el-table-column prop="approvalOpinion" label="审批意见" align="left" />
      <el-table-column prop="approvalTime" label="审批时间" align="left" />
    </el-table>

    <div slot="footer" class="dialog-footer">
      <el-button type="default" size="mini" @click="closeDialog">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getRefundApplyInfo } from '@/API/index.js';

export default {
  data () {
    return {
      isShow: false,
      formData: {},
      tableData: []
    };
  },

  methods: {
    openDialog ({ telApprovalId }) {
      this.isShow = true;
      this.queryData(telApprovalId);
    },

    closeDialog () {
      this.isShow = false;
      this.formData = {};
      this.tableData = [];
    },

    queryData (id) {
      getRefundApplyInfo({ telApprovalId: id }).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          this.formData = data;
          this.tableData = data.approvalRecords || [];
        }
      });
    }
  }
};
</script>
